import { UPDATE_ORDERS_WIDGET } from "./actionTypes";

const initialState = {
  data : {}
};

const ordersWidget = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ORDERS_WIDGET:
      state = { ...state, data: action.payload};
      break;
    
    default:
      break;
  }
  return state;
};

export default ordersWidget;
